import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './Home';
import LegalPage, { LegalLinks } from './LegalPage';
import MaintenancePage from './MaintenancePage';
import WatcherBackground from './WatcherBackground';

function IntroPage() {
  return (
      <div className="crunchy">
        <WatcherBackground />
      </div>
  );
}

function App() {
  const maintenance = process.env.REACT_APP_MAINTENANCE === 'true';

  if (maintenance) {
    return (
      <Router>
        <Routes>
          <Route path="/privacy" element={<LegalPage doc="privacy" />} />
          <Route path="/terms" element={<LegalPage doc="terms" />} />
          <Route path="*" element={<MaintenancePage />} />
        </Routes>
        <LegalLinks />
      </Router>
    );
  }

  return (
    <>
      <Router>
        <Routes>
          <Route path="/maintenance" element={<MaintenancePage />} />
          <Route path="/" element={<IntroPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/privacy" element={<LegalPage doc="privacy" />} />
          <Route path="/terms" element={<LegalPage doc="terms" />} />
        </Routes>
        <LegalLinks />
      </Router>
    </>
  );
}

export default App;
